module.exports = __webpack_public_path__ + "img/casestudies-banner.d80aabe3.png";